export default (uuid: string, identifyProperties: Record<string, unknown> = {}) => {
  try {
    (window as any).analytics.identify(uuid, identifyProperties);
  } catch (error) {
    window.Raven.captureException(error, {
      extra: {
        uuid,
        identifyProperties,
      },
    });
  }
};
